import React from 'react';
import { makeStyles, Grid, Typography, IconButton, } from '@material-ui/core';
import SortIcon from '@material-ui/icons/Sort';
import { TextField, Button } from '../components'
import { SearchIcon, RecordIcon, GridIcon } from '../icons'

export default function PaperOptions(props) {

    const { 
        query, changeSize, setChangeSize, viewList, 
        setViewList, filterList, title, onClickButton,
        textButtonL, textButtonR, buttons, buttonActive, 
        popoverId, handleClickPopover
    } = props
    
    const classes = useStyles({buttonActive, ...props})()

    return (
        <Grid container className={classes.container}>
        {
            !changeSize &&
            <Grid container justify="flex-start" alignItems="center" item md={4} xs={4}>
            <Typography component="h1" variant="h1" align="center">{title}</Typography>
            </Grid>
        }
            <Grid container justify="center" item md={8} xs={changeSize? 2 : 2} >
                <IconButton disabled={buttonActive? true : false} aria-describedby={popoverId} onClick={event => handleClickPopover(event)} style={{width:45, height:45}}> <SortIcon style={{color:buttonActive? "#CCCCCC" : "#2196C0"}} /> </IconButton>
            </Grid>
            <Grid container justify="center" item md={8} xs={changeSize? 2 : 2} >
                <IconButton onClick={() => setViewList(true)} style={{backgroundColor:viewList ? "#2196C0" : "unset", width:45, height:45}}> <RecordIcon color={viewList? "white":"#2196C0"} /> </IconButton>
            </Grid> 
            <Grid container justify="center" item md={8} xs={changeSize? 2 : 2} >
                <IconButton onClick={() => setViewList(false)} style={{backgroundColor:viewList ? "unset" : "#2196C0", width:45, height:45}}> <GridIcon color={viewList?"#2196C0":"white"}/> </IconButton>
            </Grid>
            <Grid container justify="center" item md={8} xs={changeSize? 6 : 2} >
                    <TextField 
                        type={"text"}
                        name={"query"}
                        value={query}
                        placeholder={changeSize? "¿Qué estás buscando?" : ""}
                        fontWeight="bold"
                        style={{width:50, justifyContent:!changeSize ? "center": "flex-end"}}
                        showIcon
                        iconComponent={changeSize? null : () => <SearchIcon onClick={!changeSize ? () => setChangeSize(!changeSize) : () => {}}/>}
                        onClickIcon={() => {}}
                        onChange={(e) => filterList(e.target.value)}
                    />
            </Grid>
            {
                buttons && 
                <Grid container justify="space-between" spacing={2} className={classes.buttonGroup}>
                    <Grid item xs={6}>
                        <Button fullWidth onClick={() => onClickButton(0, false)}>{textButtonL}</Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button fullWidth onClick={() => onClickButton(1, true)}>{textButtonR}</Button>
                    </Grid>
                </Grid>
            }
        </Grid>
    );
}

const useStyles = ({buttonActive, index, ...props}) => makeStyles((theme) => ({
    container:{
        [theme.breakpoints.up("md")]:{
            display:"none"
        }
    },
    buttonGroup:{
      margin:"21px 0 0 0",
      width:"100%",
      '& div:nth-child(1)':{
        paddingLeft:0,
        '& button':{
          backgroundColor:buttonActive ? '#FFF' : theme.palette.secondary.main,
          fontWeight: "bold",
          fontSize: "0.875rem",
          lineHeight: "1.063rem",
          height:37,
          borderRadius:25,
          color:buttonActive ? theme.palette.secondary.main :"#FFF",
          border: buttonActive ? `1px solid ${theme.palette.secondary.main}` : 'unset',
          boxSizing: "border-box",
          '&:hover':{
              backgroundColor:buttonActive ? '#FFF' : theme.palette.secondary.main,
          }
        }
      },
      '& div:nth-child(2)':{
        paddingRight:0,
        ' & button':{
          backgroundColor: buttonActive? theme.palette.secondary.main : "#FFF",
          color:buttonActive ? '#FFF' : theme.palette.secondary.main,
          fontWeight: "bold",
          fontSize: "0.875rem",
          lineHeight: "1.063rem",
          height:37,
          borderRadius:25,
          border: `1px solid ${theme.palette.secondary.main}`,
          boxSizing: "border-box",
          '&:hover':{
              backgroundColor:buttonActive? theme.palette.secondary.main : "#FFF",
          }
        }
      }
    }
  }));